import React, { useState, useEffect } from 'react';


import { EditorState, convertFromHTML, ContentState, convertToRaw  } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import { Editor } from 'react-draft-wysiwyg';

import htmlToDraft from 'html-to-draftjs';

 
import 'draft-js-table-plugin/lib/plugin.css';
import 'draft-js/dist/Draft.css';

 

import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import Config from '../Config';


 

 




//https://www.npmjs.com/package/draftjs-to-html


function BkTextEditor(props)
{
  
  var ref_tmp = 0;
  if(props.refresh != null) ref_tmp = props.refresh;

  const [refresh, setRefresh] = useState(ref_tmp);


  var miniTmp = "0";
  if(props.mini != null && props.mini != undefined ) miniTmp = props.mini;
  const [mini, setMini] = useState( miniTmp );

  const [convertedContent, setConvertedContent] = useState(null); 
 


 



  const [editorState, setEditorState] = useState(() => 
        {

          var defHTML = "";
          if(props.value != null && props.value != undefined)
          {
            defHTML = props.value;
          }


          const blocksFromHtml = htmlToDraft(defHTML);
          const { contentBlocks, entityMap } = blocksFromHtml;
          const content = ContentState.createFromBlockArray(contentBlocks, entityMap);


         /*//wywalone bo usuwa sytyle..
          const content = ContentState.createFromBlockArray(
              convertFromHTML( defHTML)                         
          )*/

            return EditorState.createWithContent(content);
          }
  );


  const uploadFile = (formData) => {
    
    console.log("uploadFile", formData);

    return {
      data: 'https://elizak.edu.pl/app/view/themes/ElizakPageOTheme/images/logo_n.png',
    }
  }

  const uploadCallback = (file) => {

    
      console.log(file);

      return new Promise((resolve, reject) => {
        const reader = new window.FileReader();
        console.log(reader);
        reader.onloadend = async () => {
          const form_data = new FormData();
          form_data.append("file", file);
          const res = await uploadFile(form_data);
          //setValue("thumbnail", res.data);
          resolve({ data: { link: Config.master + res.data } });
        };
        reader.readAsDataURL(file);
      });


  };





//-----------------------------------------
 

//-----------------------------------------






  var configW = { 
    image: {      
      inputAccept: 'image/gif,image/jpeg,image/jpg,image/png,image/svg',
      uploadCallback: uploadCallback,
      previewImage: true,
      urlEnabled: true, 
      uploadEnabled: true, 

      inline: { inDropdown: true },
      list: { inDropdown: true },
      textAlign: { inDropdown: true },
      link: { inDropdown: true },
      history: { inDropdown: true },
  
    }
  };



  if(mini == "1")
  {
      configW = { 

            options: ['inline', 'blockType', 'fontSize', 'fontFamily', 'list', 'link','textAlign', 'colorPicker', 'embedded', 'remove', 'history'],            
            list: {
                options: ["unordered", "ordered"],
            },
            fontSize: { inDropdown: true },
            fontFamily: { inDropdown: true},
            colorPicker: { inDropdown: true },
            history: { inDropdown: true },
      };
  }

 

  


  useEffect(() => {

    //let html = convertToHTML(editorState.getCurrentContent());
    var html = convertToRaw(editorState.getCurrentContent()); 
    html = draftToHtml(html);  

    setConvertedContent(html);

    if(props.onChange != undefined)
    {
      props.onChange(html);
    }

    if(props.valChange != null && props.valChange != undefined)
      {
          var correct = true;
          var newVal = html;

          props.valChange(props.name, newVal, correct,'');
      }else
      {
          console.log('No support for valChange');
      } 

      console.log("useEffect, editorState");

  }, [editorState]);


 

  if(props.refresh != null && props.refresh != refresh)
  {
        setRefresh(props.refresh);

        /*
        setEditorState(
          () =>  EditorState.createWithContent(
            ContentState.createFromBlockArray(
              convertFromHTML(props.value)
            )
          ),
        );*/


        setEditorState(() => 
          {
  
            var defHTML = "";
            if(props.value != null && props.value != undefined)
            {
              defHTML = props.value;
            }
  
  
            const blocksFromHtml = htmlToDraft(defHTML);
            const { contentBlocks, entityMap } = blocksFromHtml;
            const content = ContentState.createFromBlockArray(contentBlocks, entityMap);
  
  
           /*//wywalone bo usuwa sytyle..
            const content = ContentState.createFromBlockArray(
                convertFromHTML( defHTML)                         
            )*/
  
              return EditorState.createWithContent(content);
            });


        console.log("refresh");
  }



  

  return  <div className='bk_editor'>

 
    


           <Editor
              toolbar={configW}
              editorState={editorState}
              onEditorStateChange={setEditorState}
              wrapperClassName="wrapper-class"
              editorClassName="editor-class"
              toolbarClassName="toolbar-class"

               
           
            />
  </div>
}


export default BkTextEditor;